import { ErrorTextVariantType } from '../../../../../components/errorText/types/errorText';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
const PARENT_CONTAINER_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'row',
    column_gap: FOUNDATIONS.spacing_100,
});
const MESSAGE_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    font_variant: TextVariantType.FONT_PARAGRAPH_350,
    font_weight: FONT_WEIGHT.font_regular,
});
const ICON_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_250,
    height: FOUNDATIONS.size_250,
});
export const getErrorTextStyles = (FOUNDATIONS, FONT) => {
    return {
        [ErrorTextVariantType.REGULAR]: {
            parentContainer: {
                ...PARENT_CONTAINER_COMMON_TOKENS(FOUNDATIONS, FONT),
            },
            message: {
                ...MESSAGE_COMMON_TOKENS(FOUNDATIONS, FONT),
                color: FOUNDATIONS.color_feedback_error_font_50,
            },
            icon: {
                ...ICON_COMMON_TOKENS(FOUNDATIONS, FONT),
                color: FOUNDATIONS.color_feedback_error_font_50, // change to Color/Feedback/Error/Icon/75 when available
            },
        },
        [ErrorTextVariantType.ALTERNATIVE]: {
            parentContainer: {
                ...PARENT_CONTAINER_COMMON_TOKENS(FOUNDATIONS, FONT),
            },
            message: {
                ...MESSAGE_COMMON_TOKENS(FOUNDATIONS, FONT),
                color: FOUNDATIONS.color_feedback_error_font_50,
            },
            icon: {
                ...ICON_COMMON_TOKENS(FOUNDATIONS, FONT),
                color: FOUNDATIONS.color_feedback_error_font_50, // change to token when available
            },
        },
    };
};
//# sourceMappingURL=styles.js.map